<template>
    <div class="left-nav">
        <ul>
            <li :title="item.label" class="left-label" :class="{defauleColor:id == item.id}" v-for="item in list" :key="item.id" @click="handleList(item.id)">{{item.label}}</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'QihuibaoWebLeftnav',
    props:{
        list:{
            type:Array,
        }
    },
    data() {
        return {
            id:this.list[0].id,
        };
    },

    mounted() {
        
    },

    methods: {
        handleList(id){
            this.id = id;
            this.$emit('handleList', id);
        }
    },
};
</script>

<style lang="scss" scoped>
.left-nav{
    position: absolute;
    padding: 0 20px;
    left: -300px;
    top: 60px;
    width: 300px;
    .left-label{
        cursor: pointer;
        line-height: 40px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .defauleColor{
        color: #DD122B;
    }
}

@media screen and (max-width: 540px) {
    .left-nav{
        padding: 0 5px ;
        left: -100px ;
        width: 100px ;
        font-size: 13px ;
        .left-label{
            line-height: 30px;
        }
    }
}

@media screen and (max-width: 960px) and (min-width: 540px){
    .left-nav{
        padding: 0 10px;
        left: -150px;
        width: 150px;
        font-size: 14px;
    }
}

@media screen and (max-width: 1280px) and (min-width: 960px){
    .left-nav{
        padding: 0 15px;
        left: -200px;
        width: 200px;
        font-size: 14px;
    }
}

@media screen and (min-width: 1280px) and (max-width: 1500px){
    .left-nav{
        padding: 0 15px;
        left: -200px;
        width: 200px;
        font-size: 14px;
    }
}


</style>